import { http } from 'http';

export default {
  uploadDocument: ({ container, folder, docType, file }) =>
    http.post(
      `/prospects/onboarding/UploadDocumentProspect/${container}/${folder}/${docType}`,
      file,
      {
        headers: { 'content-type': 'multipart/form-data' }
      }
    ),
  appliedConsents: (operationGuid, params) =>
    http.post(`/webh/appliedconsents?id=${operationGuid}`, params)
};
